<template>
  <div
    :class="[$style.box]"
    :style="{background: params.background}"
  >
    <div
      :class="$style.icon"
    >
      <svg-sprite
        :name="params.iconName"
        :size="params.iconSize"
        :type="params.iconType"
        :color="params.iconColor"
      />
    </div>
    <div :class="$style.message"
    :style="{width: customWidth}">
      <div
        :style="styles.message"
        v-html="text"
      />
    </div>
    <div
      v-if="closeButton"
      :class="$style.close"
    >
      <vgp-icon-button
        size="small"
        :icon="{ name:'close-1', type:'regular', size: 20 }"
        :colors="buttonColors"
        @onClick="$emit('onClose')"
      />
    </div>
  </div>
</template>

<script>
import svgSprite from '$$uiKitComp/VueIcon/svgSprite.vue';
import vgpIconButton from '$$uiKitComp/globalButton/withIcon/iconButton.vue';

const defaultStyles = {
  message: { 'font-size': '14px', 'white-space': 'nowrap' },
};

export default {
  name: 'InlineNotification',
  components: {
    svgSprite, vgpIconButton,
  },
  props: {
    type: { type: String },
    text: { type: String, default: '' },
    messageStyles: { type: Object, required: false, default: () => {} },
    closeButton: { type: Boolean, default: false },
    customWidth: { type: String, default: '' },
  },
  emits: {
    onClose: null,
  },
  data() {
    return {
      defaultParams: {
        background: '#FFEBCC',
        iconName: 'warning-1',
        iconSize: 20,
        iconType: 'bold',
        iconColor: '#FF9A00',
      },
      buttonColors: {
        color: '#333333',
        labelColor: '#191919',
        activeColor: '#333333',
      },
    };
  },
  computed: {
    params() {
      if (this.type === 'warning') {
        return {
          background: '#FFEBCC',
          iconName: 'warning-1',
          iconSize: 20,
          iconType: 'bold',
          iconColor: '#FF9A00',
        };
      }

      if (this.type === 'info') {
        return {
          background: '#FFEBCC',
          iconName: 'info',
          iconSize: 20,
          iconType: 'bold',
          iconColor: '#1565C0',
        };
      }

      return this.defaultParams;
    },
    styles() {
      return {
        message: {
          ...defaultStyles.message,
          ...this.messageStyles,
        },
      };
    },
  },

};
</script>

<style module src='./less/nofitication.less' lang="less"></style>
